/**
 * Utility function that listens for message events being broadcast on the
 * window object, and if the type matches the expected type, the given callback
 * is invoked.
 */
const NIADomainList = [
  'https://app-2luyhoszfh4j2.azurewebsites.net',
  'https://app-6xopndoptm7q2.azurewebsites.net',
]

export default function listen(type, fn) {
  // the listener function, which will invoke the `fn` parameter if the message
  // type matches, and it came from the same origin.
  const listener = event => {
    if (
      event.origin === window.location.origin && event.data.type && event.data.type.indexOf(type) === 0
      || NIADomainList.includes(event.origin) && event.data.type && event.data.type.indexOf(type) === 0
    ) {
      fn(event.data.data)
    }
  }

  window.addEventListener('message', listener)

  // return a function that the callee can use to cancel the event listener.
  return function cancelListener() {
    window.removeEventListener('message', listener)
  }
}
